import React, { useEffect, useState } from "react";
import { Box, Flex, Menu, MenuButton, MenuList, Text, useColorModeValue} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import RecordTable from "./RecordTable/RecordTable";
import { InvoiceNumberFormate } from "jsFunctions/helperFunctions";
import {  tdsRecordColumns } from "./RecordTable/ColumnData";
import { fetchAsyncSearchTdsRecords } from "redux/invoicePaymentRecordSlice";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { currencySymbolByCode } from "components/allForm/SalesItem/currencyJson";
import InvoiceTdsInfoModel from "components/models/invoiceTdsInfoModel";
import { FaEllipsisV } from "react-icons/fa";
import { CiExport } from "react-icons/ci";
import ExportDataModel from "components/exportData/ExportDataModel";

const InvoiceTdsRecords = () => {
  const [tdsRecordData, setTdsRecordData] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [openTdsInfoModel, setOpenTdsInfoModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const currUser = useSelector((state) => state.auth.currUser);
  const [role,setRole] = useState('')  

  useEffect(()=>{
    if(currUser && currUser?.auth){
      const auth = currUser?.auth;
      const roleObj = auth && auth?.length > 0 && auth.find((item)=> item?.module === 'Invoice Tds');
      if(roleObj){
        setRole(roleObj?.access)
      }
    }
  },[currUser])

  const tdsRecords = useSelector((state) => state.tdsRecords);
  const dispatch = useDispatch();
 
  useEffect(() => {
    setLoading(true); 
    dispatch(fetchAsyncSearchTdsRecords({}))
      .then(() => {
        setLoading(false); 
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false); 
      });
  }, []);

  useEffect(() => {
    if (tdsRecords?.recordsData && tdsRecords?.recordsData.length > 0) {
      const tableData = tdsRecords?.recordsData.map((record, index) => {
        return {
          _id:record._id,
          no: index + 1,
          inNo: (
            <span 
              style={{ cursor: "pointer",color:'blue'}}
            >
              {record.inId ? InvoiceNumberFormate(record?.inId?.inNo) : "-"}
            </span>
          ),
          client: <span>{record?.cId?.clName || "-"}</span> ,
          percentage:(<span>{record?.prc || '-'} %</span>),
          sortBaseAmt:record?.bsAmt || 0,
          baseAmount:(
            <span>
              {currencySymbolByCode(record?.inId?.inCr || "INR")} {formatAmountIndianRupees(record?.bsAmt || 0)}
            </span>
          ),
          tdsAmount:(
            <span className="f-600 green">
              {currencySymbolByCode(record?.inId?.inCr || "INR")} {formatAmountIndianRupees(record?.tdsAmt || 0)}
            </span>
          ),
         
          invoiceDate: dateTimeFormat(record?.inId?.inDt),
        };
      });
      setTdsRecordData(tableData);
    } else {
      setTdsRecordData([]);
    }
  }, [tdsRecords]);

  const handleRowClick = (e,_id)=>{
    e.stopPropagation();
    const data = tdsRecords.recordsData.filter((item)=> item?._id === _id)
    setSelectedItem(data[0]);
    setOpenTdsInfoModel(true);
  }

  const closeTdsInfoModel = () => {
    setOpenTdsInfoModel(false);
    setSelectedItem({});
  };
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );
  let menuBg = useColorModeValue("white", "navy.800");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
  const [isOpen, setIsOpen] = useState(false);
  const [activeBtn,setActiveBtn] = useState("")

  const toggleMenu = (btn) => {
    setIsOpen(!isOpen);
    setActiveBtn(btn)
  };
  const handleClose = () => {   
    setActiveBtn("");   
    setIsOpen(false)
  };

  if (loading) {
    return (
      <SpinnerLoader/>
    );
  }
  return (
    <>
       <Box  display="flex" className="mx-3" justifyContent="space-between">
       <Box display="flex">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
          mt={5}
        >
          Invoice TDS
        </Text>
        </Box>
        <Box display="flex" mt={2} className="add-new-btn">
        <Box>
          <Menu>
          <MenuButton p="0px">
          <Box  className='menu-ellipsis-btn'><FaEllipsisV /></Box>

          </MenuButton>
          <MenuList
             boxShadow={shadow}
             p="0px"
             mt="10px"
             borderRadius="10px"
             bg={menuBg}
             border="none"
          >
            <Flex w="100%" mb="0px" flexDirection="column">
            <Box
                ps="20px"
                pt="10px"
                pb="8px"
                className="menu-text"
                borderBottom="1px solid gray"
                borderColor={borderColor}
                onClick={()=>toggleMenu('xlsx')}
                display="flex"
              >
                <CiExport size={20} className="mx-1"/> <span>Export XLSX</span>
              </Box>
            </Flex>
            <Flex w="100%" mb="0px" flexDirection="column">
            
            </Flex>
           <Box marginRight={40}>
           {isOpen && (
            <ExportDataModel
              filename={"Invoice TDS_"}
              type="invoiceTds"
              role={role}
              isOpen={isOpen}
              handleClose={handleClose}
              activeBtn={activeBtn}
            />
          )}
           </Box>
          </MenuList>
        </Menu>
          </Box>
        </Box>
      </Box>
      <Box pt={{ base: "40px", md: "10px", xl: "10px" }}>
        <RecordTable
          columnsData={tdsRecordColumns}
          tableData={tdsRecordData}
          type={"Invoice Tds"}
          role={role}
          expenseType = 'Invoice Tds'
          openInfoModal = {handleRowClick}
        />
      </Box>
      {openTdsInfoModel && (
        <InvoiceTdsInfoModel
          openInfoModal={openTdsInfoModel}
          closeInfoModal={closeTdsInfoModel}
          selectedItem={selectedItem}   
          role={role}
     
        />
      )}
    </>
  );
};

export default InvoiceTdsRecords;
